import React, { useEffect } from "react"
import { useAuth } from "../hooks/useAuth"
import LayoutLoading from "../components/Layouts/LayoutLoading"

function Logout() {
  const { logout } = useAuth()

  useEffect(() => {
    logout()
  }, [logout])

  return (
    <LayoutLoading>
      <p className="text-center">Выход из системы...</p>
    </LayoutLoading>
  )
}

export default Logout
